<template>
  <v-card class="filters-card mb-4">
    <v-card-text>
      <div class="filters-row">
        <v-text-field
          :model-value="searchQuery"
          @update:model-value="$emit('update:searchQuery', $event)"
          placeholder="Search by student name or school..."
          variant="outlined"
          density="compact"
          prepend-inner-icon="mdi-magnify"
          hide-details
          class="search-box"
        ></v-text-field>

        <v-select
          :model-value="filterStatus"
          @update:model-value="$emit('update:filterStatus', $event)"
          :items="statusOptions"
          label="Status"
          variant="outlined"
          density="compact"
          hide-details
          class="filter-select"
          multiple
          :menu-props="{ maxHeight: 300 }"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 1" size="small" closable @click:close="removeStatus(item.value)">
              {{ item.title }}
            </v-chip>
            <span v-if="index === 1" class="text-grey text-caption">
              (+{{ filterStatus.length - 1 }} more)
            </span>
          </template>
        </v-select>

        <v-select
          :model-value="filterSchool"
          @update:model-value="$emit('update:filterSchool', $event)"
          :items="schoolOptions"
          label="School"
          variant="outlined"
          density="compact"
          hide-details
          class="filter-select"
        ></v-select>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
const props = defineProps<{
  searchQuery: string
  filterStatus: string[]
  filterSchool: string
  schoolOptions: Array<{ title: string, value: string }>
}>()

const emit = defineEmits<{
  'update:searchQuery': [value: string]
  'update:filterStatus': [value: string[]]
  'update:filterSchool': [value: string]
}>()

const statusOptions = [
  { title: 'Pending', value: 'pending' },
  { title: 'Filled', value: 'filled' },
  { title: 'Completed', value: 'completed' },
  { title: 'Denied', value: 'denied' }
]

const removeStatus = (value: string) => {
  const newStatus = props.filterStatus.filter(s => s !== value)
  emit('update:filterStatus', newStatus)
}
</script>

<style scoped>
.filters-row {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.search-box {
  flex: 3;
  min-width: 250px;
}

.filter-select {
  flex: 1;
  min-width: 180px;
  max-width: 250px;
}

@media (max-width: 768px) {
  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box,
  .filter-select {
    width: 100%;
  }
}
</style>
